module.exports = __webpack_public_path__ + "media/images/lov_it4-0d6d3241190d26ec8119a674fa3acbea.jpg";